import TenantVehicles from './TenantVehicles';
import {ActionCreators} from '../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, getClient, getLocation} from '../../reducers/rootReducer';

const mapStateToProps = state => {
  const {user, users} = getUser(state);
  const {clients, client} = getClient(state);
  const {locations, location, loadingWhitelist, loadedWhitelist, whitelist} = getLocation(state);

  return {
    user,
    users,
    clients,
    client,
    locations,
    location,
    loadingWhitelist,
    loadedWhitelist,
    whitelist
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TenantVehicles);
